import React, { useEffect } from 'react';
import JumboAppContext from "@jumbo/components/JumboApp/JumboAppContext";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from 'stores/auth';
import { CircularProgress } from '@mui/material';
import { NotificationManager } from 'react-notifications';

const JumboApp = (props) => {
    const [activeLayout, setActiveLayout] = React.useState(props.activeLayout);
    const [rebuildRoutes, setRebuildRoutes] = React.useState(true);


    const search = useLocation().search;
    const dispact = useDispatch();

    useEffect(() => {

        const params = new URLSearchParams(search);
        const userId = params.get("userId");
        const pwd = params.get("pwd");
        const token = params.get("token");
        const language = params.get("lng");

        if (userId !== null) {
            localStorage.setItem("userToken", token);
            dispact(loginUser({ userId, pwd }));


        }



    }, [])

    React.useEffect(() => {
        if (rebuildRoutes) {
            setRebuildRoutes(false);
        }
    }, [rebuildRoutes]);

    const appContextValue = React.useMemo(() => {
        return {
            activeLayout,
            setActiveLayout,
            rebuildRoutes,
            setRebuildRoutes,
        }
    }, [activeLayout, setActiveLayout, rebuildRoutes, setRebuildRoutes]);

    const { authUser, isLoading, isError, isSuccess, message } = useSelector(state => state.auth)

    useEffect(() => {
        if (isError) {
            NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor. ' + message)

        }

    }, [authUser, isLoading, isError, isSuccess, message, dispact])

    if (isLoading) {
        return <CircularProgress />
    }

    return (
        <JumboAppContext.Provider value={appContextValue}>

            {props?.children}
        </JumboAppContext.Provider>
    );


};

export default JumboApp;